import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

export const DomainTab = ({ domain, img, index, showService }) => {
    const [isActive, setIsActive] = useState(false);
    const [selectedServiceCount, setSelectedServicesCount] = useState(0);

    const domainName = domain?.name ?? "";

    const selectedDomains = useSelector(
        (state) => state.onboardForm.domains
    );

    useEffect(() => {
        let active = false;
        let count = 0;

        selectedDomains.forEach((d) => {
            if (d.id === domain.id && d.subCategory?.length) {
                active = true;
                count = d.subCategory.length;
            }
        });

        setIsActive(active);
        setSelectedServicesCount(count);
    }, [selectedDomains, domain.id]);

    const popover = useMemo(() => {
        return (
            <div className="domaincards domainExplainPopover">
                <div className="card w-220p border-0 shadow">
                    <div className="card-body">
                        <div className="row pop-header">
                            <div className="col-9">
                                <p className="mb-0 font-8 text-light-default font-weight-600">
                                    Domain Details
                                </p>

                                <p className="mb-2 text-default font-weight-700">
                                    {domainName}
                                </p>
                            </div>

                            <div className="col-3 pl-0 text-right">
                                <img
                                    src={img}
                                    alt={domainName}
                                    style={{
                                        width: 40,
                                        height: 40,
                                    }}
                                />
                            </div>
                        </div>

                        <p className="mb-0">
                            {domain.description}
                        </p>
                    </div>
                </div>
            </div>
        );
    }, [domain, img, domainName]);

    return (
        <div className="col-12 col-md-3">
            <div className="domain-wrapper">
                <div className="checkboxStyleOne">
                    <input
                        type="checkbox"
                        id={`domain${index}`}
                        checked={isActive}
                        readOnly
                        onChange={() => showService(domain)}
                    />

                    <label htmlFor={`domain${index}`}>
                        <img
                            src={img}
                            alt={domainName}
                            style={{
                                width: 40,
                                height: 40,
                            }}
                        />
                    </label>

                    {selectedServiceCount !== 0 && (
                        <span className="count">
                            {selectedServiceCount}
                        </span>
                    )}
                </div>

                {popover}
            </div>

            <p
                className={`text-default font-12 text-center ${
                    isActive ? "font-weight-700" : ""
                }`}
            >
                {domainName}
            </p>
        </div>
    );
};